import VuexFire from 'vuexfire'
import { firebaseMutations, firebaseAction } from 'vuexfire'
import helpers from './../../helpers.js'

export default {

    state: {

        users: null,
        clients: null,
        projects: null,
        specs: null,
        economyposts: null,
        timelogs: null,
        timebookings: null,
        tasks: null,
        tasklists: null,
        comments: null,

    },// state

    getters:{

        // objs to array for easier filtering throughout
        /*
        firebase_arrays(state,getters){
            return {
                projects: helpers.keyedObjectToArray(state.projects),
                clients: helpers.keyedObjectToArray(state.clients),
                economyposts: helpers.keyedObjectToArray(state.economyposts),
                specs: helpers.keyedObjectToArray(state.specs),
                timelogs: helpers.keyedObjectToArray(state.timelogs),
                users: helpers.keyedObjectToArray(state.users),
                comments: helpers.keyedObjectToArray(state.comments),
                users: helpers.keyedObjectToArray(state.users),
            }
        },
        */

    },

    mutations: firebaseMutations,

    actions: {

        setVuexFireRef: firebaseAction(({ bindFirebaseRef }, input) => {
            bindFirebaseRef( input.key, input.ref )
        }),

    },// actions

}


// WEBPACK FOOTER //
// ./src/store/modules/firebase.js